import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { Path } from './styles/Path';

function PixLogo({
  variant,
  width,
  height,
  className,
}) {
  const alt = useIntl().formatMessage({ id: 'PIX.HERO.PIX_LOGO.ALT' });
  return (
    <svg
      alt={alt}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 86 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M35.0123 27.5112C34.7164 27.5112 34.4629 27.2608 34.4629 26.9688V10.4912C34.4629 7.02886 37.337 4.19238 40.8452 4.19238H46.0441C49.5523 4.19238 52.4268 7.02886 52.4268 10.4912V14.788C52.4268 18.2504 49.5523 21.0871 46.0441 21.0871H37.929C37.6331 21.0871 37.3791 20.8367 37.3791 20.5447C37.3791 20.2526 37.6331 20.0024 37.929 20.0024H46.0441C48.9606 20.0024 51.3701 17.6663 51.3701 14.7463V10.4497C51.3701 7.57132 49.0031 5.23527 46.0866 5.23527H40.8877C37.9712 5.23527 35.5617 7.57116 35.5617 10.4912V26.9688C35.5194 27.2608 35.3082 27.5112 35.0123 27.5112Z"
        variant={variant}
      />
      <Path
        d="M57.9665 21.1704C57.6706 21.1704 57.4171 20.9202 57.4171 20.6282V7.11245C57.4171 6.11129 56.5715 5.27682 55.5571 5.27682H53.317C53.0211 5.27682 52.7676 5.02661 52.7676 4.7346C52.7676 4.44259 53.0211 4.19238 53.317 4.19238H55.5571C57.1633 4.19238 58.5159 5.48556 58.5159 7.11245V20.6282C58.5159 20.9202 58.2623 21.1704 57.9665 21.1704Z"
        variant={variant}
      />
      <Path
        d="M57.1633 2.5239L56.8248 2.19005C56.4021 1.7729 56.4021 1.06386 56.8248 0.646709L57.1633 0.312865C57.586 -0.104288 58.3042 -0.104288 58.7269 0.312865L59.0654 0.646709C59.488 1.06386 59.488 1.7729 59.0654 2.19005L58.7269 2.5239C58.3042 2.94105 57.586 2.94105 57.1633 2.5239Z"
        variant={variant}
      />
      <Path
        d="M64.4755 21.087H62.2354C61.9395 21.087 61.6855 20.8366 61.6855 20.5446C61.6855 20.2526 61.9395 20.0024 62.2354 20.0024H64.4755C65.4899 20.0024 66.4197 19.6269 67.1383 18.9177L72.3372 13.8701C72.7598 13.453 73.3515 13.2026 73.9433 13.2026C74.535 13.2026 75.1271 13.453 75.5498 13.8701L80.7487 18.9177C81.4672 19.6269 82.397 20.0024 83.4115 20.0024H85.2289C85.5248 20.0024 85.7783 20.2526 85.7783 20.5446C85.7783 20.8366 85.5248 21.087 85.2289 21.087H83.4115C82.1012 21.087 80.8756 20.5862 79.9879 19.6685L74.7886 14.6211C74.5773 14.4125 74.2814 14.2873 73.9433 14.2873C73.6051 14.2873 73.3093 14.4125 73.0979 14.6211L67.899 19.6685C67.0114 20.5862 65.7858 21.087 64.4755 21.087Z"
        variant={variant}
      />
      <Path
        d="M64.4755 4.19238H62.2354C61.9395 4.19238 61.6855 4.44259 61.6855 4.7346C61.6855 5.02661 61.9395 5.27682 62.2354 5.27682H64.4755C65.4899 5.27682 66.4197 5.6523 67.1383 6.36146L72.3372 11.409C72.7598 11.8262 73.3515 12.0765 73.9433 12.0765C74.535 12.0765 75.1271 11.8262 75.5498 11.409L80.7487 6.36146C81.4672 5.6523 82.397 5.27682 83.4115 5.27682H85.2289C85.5248 5.27682 85.7783 5.02661 85.7783 4.7346C85.7783 4.44259 85.5248 4.19238 85.2289 4.19238H83.4115C82.1012 4.19238 80.8756 4.69293 79.9879 5.61066L74.7886 10.6583C74.5773 10.8668 74.2814 10.9919 73.9433 10.9919C73.6051 10.9919 73.3093 10.8668 73.0979 10.6583L67.899 5.61066C67.0114 4.69293 65.7858 4.19238 64.4755 4.19238Z"
        variant={variant}
      />
      <Path
        d="M6.52642 22.923C7.62539 22.923 8.68209 22.5059 9.48518 21.7133L13.7545 17.5C14.0504 17.208 14.5577 17.208 14.8958 17.5L19.2068 21.7548C20.0099 22.5474 21.0666 22.9648 22.1656 22.9648H23.0109L17.6007 28.3042C15.91 29.9728 13.1626 29.9728 11.4719 28.3042L6.01953 22.923H6.52642Z"
        variant={variant}
      />
      <Path
        d="M22.123 7.98839C21.0241 7.98839 19.9674 8.40571 19.1643 9.1983L14.8528 13.4531C14.557 13.7451 14.0497 13.7451 13.7115 13.4531L9.44262 9.23985C8.63953 8.44726 7.58283 8.03015 6.48386 8.03015H5.97656L11.4293 2.64892C13.12 0.980308 15.8674 0.980308 17.5582 2.64892L22.9684 7.98839H22.123Z"
        variant={variant}
      />
      <Path
        d="M1.49616 12.41L4.75087 9.19801H6.5258C7.28662 9.19801 8.04761 9.49001 8.5971 10.0323L12.866 14.2454C13.2464 14.6208 13.7961 14.8296 14.3033 14.8296C14.8105 14.8296 15.3601 14.6208 15.7406 14.2454L20.0516 9.99056C20.601 9.44826 21.362 9.15625 22.1229 9.15625H24.2363L27.491 12.3682C29.1817 14.0368 29.1817 16.7483 27.491 18.4169L24.2363 21.6291H22.1229C21.362 21.6291 20.601 21.3371 20.0516 20.7948L15.7406 16.5397C14.9797 15.7889 13.627 15.7889 12.8239 16.5397L8.555 20.753C8.00551 21.2953 7.24452 21.5873 6.4837 21.5873H4.70836L1.45364 18.3754C-0.194813 16.7902 -0.194565 14.0786 1.49616 12.41Z"
        variant={variant}
      />
    </svg>
  );
}

PixLogo.defaultProps = {
  className: undefined,
  variant: 'primary',
  width: 86,
  height: 30,
};

PixLogo.propTypes = {
  className: PropTypes.string,
  height: PropTypes.number,
  variant: PropTypes.oneOf(['primary', 'white']),
  width: PropTypes.number,
};

export default PixLogo;
